module.exports = __webpack_public_path__ + "img/9791189680046.149c7c8a.jpg";